import React from "react";

export default function SliceBar() {


  return (
    <div style={{
      width: 'auto',
      height: '20px',
      background: '#F8FAFB',
      marginTop:'20px'
      }}>
    </div>
  );
}
